import React, { Component } from 'react';
import Chart from 'react-apexcharts';

class HeatMap extends Component {
  constructor(props) {
    super(props);

    // Use provided data and options, or default to empty
    const seriesData = this.props.data || [];
    const options = this.props.options || {};

    // If no data or options provided, generate a default 100x10 dataset
    if (seriesData.length === 0) {
      for (let x = 0; x < 100; x++) {
        let row = {
          name: `X${x}`,
          data: []
        };
        for (let y = 0; y < 10; y++) {
          row.data.push(Math.floor(Math.random() * 10));
        }
        seriesData.push(row);
      }
    }

    // If no options provided, use default options
    if (Object.keys(options).length === 0) {
      options.chart = {
        height: 700,
        type: 'heatmap',
      };
      options.dataLabels = {
        enabled: false,
      };
      options.colors = ['#008FFB'];
      options.title = {
        text: 'HeatMap Example (100x10)',
      };
    }

    // Set the initial state
    this.state = {
      options: options,
      series: seriesData,
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.chartData,
      chartOptions: this.props.chartOptions,
    });
  }

  componentDidUpdate(prevProps) {
    // Check if `chartData` has changed
    if (this.props.chartData !== prevProps.chartData) {
      this.setState({ chartData: this.props.chartData });
    }

    // Check if `chartOptions` has changed
    if (this.props.chartOptions !== prevProps.chartOptions) {
      this.setState({ chartOptions: this.props.chartOptions });
    }
  }

  render() {
    return (
      <div className="app">
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="heatmap"
          width="100%"
          height="500px"
        />
      </div>
    );
  }
}

export default HeatMap;